import fetchStream from 'fetch-readablestream';
import { readAllChunks } from '../utils';
import { getToken } from '../utils/authUtils';
import { apiURL } from '../config';

const readBodyText = async (body) => {
    const reader = body.getReader();
    const decoder = new TextDecoder();
    let text = '';
    for (;;) {
        const { value, done } = await reader.read();
        if (done) {
            return text + decoder.decode();
        }
        text += decoder.decode(value, { stream: true });
    }
};

// A non-2xx must fail fast (a proxy timeout like Cloudflare 524 returns an
// HTML error page that must not reach the chunk parser), but a JSON error
// body carries the server's real message — surface it instead of a generic.
const errorMessageFromResponse = async (response) => {
    const fallback = `Upload failed with status ${response.status}`;
    try {
        const parsed = JSON.parse(await readBodyText(response.body));
        return parsed.errorMessage || parsed.message || fallback;
    } catch {
        return fallback;
    }
};

export const fetchReadableStream = async (url, data, setPercentage, chunksSeparator = '\n') => {
    const token = await getToken();

    const isFormData = typeof FormData !== 'undefined' && data instanceof FormData;
    const headers = { Authorization: `Bearer ${token}` };

    if (!isFormData) {
        headers['Content-Type'] = 'application/json';
    }

    return await fetchStream(`${apiURL}${url}`, {
        method: 'POST',
        headers,
        body: isFormData ? data : JSON.stringify(data),
    }).then(async (response) => {
        if (!response.ok) {
            throw new Error(await errorMessageFromResponse(response));
        }
        return readAllChunks(response.body, setPercentage, chunksSeparator);
    });
};
